import React, { useState, useEffect, useCallback, useMemo } from "react";
import { CurrentUser } from "../utils/apiCalls/auth";
import { getAccessToken } from "../services/auth";
import { UserContext } from "./UserContext";

export const UserProvider = ({ children }) => {
  const [loginUserDetails, setLoginUserDetails] = useState(null);
  const token = getAccessToken();

  const getLoginUserDetails = useCallback(async () => {
    try {
      const response = await CurrentUser();
      if (response.statusCode === 200) {
        setLoginUserDetails(response.data);
      } else {
        console.error("Error fetching current user details:", response.message);
      }
    } catch (error) {
      console.error("Error fetching current user details:", error?.message);
    }
  }, []);

  useEffect(() => {
    if (token) {
      getLoginUserDetails();
    }
  }, [token, getLoginUserDetails]);

  const clearLoginUserDetails = useCallback(() => {
    setLoginUserDetails(null);
  }, []);

  const userContextStore = useMemo(
    () => ({
      loginUserDetails,
      clearLoginUserDetails,
      getLoginUserDetails,
    }),
    [loginUserDetails, clearLoginUserDetails, getLoginUserDetails]
  );

  return <UserContext.Provider value={userContextStore}>{children}</UserContext.Provider>;
};
